import { Injectable } from '@angular/core';
import { Settings } from '../../core/settings';
import { HttpClient } from '@angular/common/http';
import { Observable, combineLatest, of } from 'rxjs';
import { SponsorStudy } from '../../sponsor-dashboard/sponsor-study';
import { map, flatMap, switchAll } from 'rxjs/operators';
import { deserialize } from 'santee-dcts';
import { Subject } from '../../subjects/Subject';
import { SubjectReadModel } from '../../subjects/subject';

@Injectable()
export class SponsorCtSubjectsStorage {
    constructor(
        private settings: Settings,
        private http: HttpClient
    ) { }

    public loadCtSubject(study$: Observable<SponsorStudy>, subjectId$: Observable<string>): Observable<Subject> {
        return combineLatest(
            study$,
            subjectId$
        ).pipe(
            map(([study, subjectId]) => {
                return this.http.get(`${this.settings.apiUrl}/sponsor/study/${study.protocolId}/ct-subjects/${subjectId}`).pipe(
                    map((response) => deserialize(response, SubjectReadModel).subject),
                );
            }),
            flatMap(x => of(of(null), x)),
            switchAll<Subject | null>()
        );
    }
}